import React, {FC, useEffect} from 'react';
import './auth.scss'
import {Outlet} from "react-router-dom";
import Image from "react-bootstrap/Image";
import logo from "../../assets/logo.svg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {availableAuthTypes} from "../../redux/actions/authAsyncActions";
import Loader from '../../components/UI/loader/Loader';

const AuthPage: FC = () => {
    const dispatch = useAppDispatch()
    const {isLoading, error} = useAppSelector(state => state.authReducer)

    useEffect(() => {
        dispatch(availableAuthTypes('2'))
    }, [])

    return (
        <div className="authContainer">
            <div className="wrap">
                <div>
                    <Image className="logoCompany" src={logo}/>
                </div>
                <br/>
                <h2>Авторизация</h2>
                {
                    isLoading ? <Loader/> : <Outlet/>
                }
                {
                    error && <p className="text-center errorValidateBlock">{error}</p>
                }
            </div>
        </div>
    );
}

export default AuthPage;
